/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Users_LabelInputs */



/**
* | output |
* | --- |
* | "Users" |
*
* @param {Team_Manager_Users_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_users_label = /** @type {((inputs?: Team_Manager_Users_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Users_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisateurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользователи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usuarios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ताओं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usuários")
	return /** @type {LocalizedString} */ ("Users")
});